import PrivateRoute, { Router } from '@Components/app-layout/PrivateRoute';

import TokensGridLayout from './containers/Grid';

export default function TokenLayout() {
  return <Router>
    <PrivateRoute path="/admin/tokens" component={TokensGridLayout} />
  </Router>
}
